import React from 'react'

export default function HelperText(props) {
    return (
        <div className='helper-text'>
            {props.children}
        </div>
    )
}
